import type { TaskLikeObject } from '@frontend/api-client';
import { Button, Divider, Text, XStack, YStack } from '@frontend/web-react';
import { EmptyTasksContainer } from '@frontend/web/components';
import { useNavigate } from '@tanstack/react-router';
import { TaskLikeCard } from '../Tasks/TaskLikeCard';
import { useTaskCardAnimation } from '../Tasks/hooks/useTaskCardAnimation';

type HomeTasksContainerProps = {
  isEmpty?: boolean;
  seeAll?: boolean;
  taskLikeObjects: TaskLikeObject[];
  title: string;
};

export const HomeTasksContainer = ({ isEmpty, seeAll, taskLikeObjects, title }: HomeTasksContainerProps) => {
  const navigate = useNavigate();
  const { animationStyle: seeAllAnimationStyle } = useTaskCardAnimation({ index: taskLikeObjects.length });
  const handleSeeAllPress = () => {
    navigate({
      to: '/app/task',
    });
  };
  if (isEmpty) {
    return <EmptyTasksContainer />;
  } else if (!taskLikeObjects.length) {
    return null;
  } else {
    return (
      <YStack accessibilityLabel={`${title} tasks`}>
        <XStack className="items-center justify-between pb-md">
          <Text isSelectable={false} type="p-sm">
            {title}
          </Text>
          {!seeAll ? (
            <Text className="text-neutral-500" isSelectable={false} type="p-sm">
              {taskLikeObjects.length}
            </Text>
          ) : null}
        </XStack>
        <YStack className="gap-sm">
          {taskLikeObjects.map((taskLikeObject, index) => (
            <TaskLikeCard
              animationIndex={index}
              isAnimated
              key={taskLikeObject.id}
              showInlineActions
              taskLikeObject={taskLikeObject}
            />
          ))}
        </YStack>
        <YStack style={seeAllAnimationStyle}>
          {seeAll ? (
            <XStack className="justify-end mt-md">
              <Button
                accessibilityLabel={`See all ${title.toLowerCase()} tasks`}
                label="See all"
                onClick={handleSeeAllPress}
                size="sm"
                variant="tertiary"
              />
            </XStack>
          ) : null}
          <Divider className="mt-lg" />
        </YStack>
      </YStack>
    );
  }
};
